import { render, staticRenderFns } from "./ReviewTabConflicting.vue?vue&type=template&id=2b395dff&"
import script from "./ReviewTabConflicting.vue?vue&type=script&lang=js&"
export * from "./ReviewTabConflicting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports